"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Phone = _interopRequireDefault(require("@rsuite/icon-font/lib/device/Phone"));

// Generated by script, don't edit it please.
var Phone = (0, _createSvgIcon["default"])({
  as: _Phone["default"],
  ariaLabel: 'phone',
  category: 'device',
  displayName: 'Phone'
});
var _default = Phone;
exports["default"] = _default;
module.exports = exports.default;